/* HTML: <div class="loader"></div> */
import React from 'react'

const ChatLoader = () => {
  return (
   <div className="loader-chat"></div>
  )
}

export default ChatLoader